// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"apps_onboarding_src_app_pages_pages_module_ts":"b65085dd738a53e5","node_modules_pnpm_qr-scanner_1_4_2_node_modules_qr-scanner_qr-scanner-worker_min_js":"71108a5adcb0ae83"}[chunkId] + ".js";
};